// extracted by mini-css-extract-plugin
module.exports = {"Heading":"OrderSummary_Heading__3VE5k","Price":"OrderSummary_Price__2vDj-","IngredientList":"OrderSummary_IngredientList__3fmoQ"};